import { ref, computed } from 'vue';
import { getToken } from '../../helpers/api';

const url =
  import.meta.env.VITE_APP_DATAPASS_API_BASE_URL ||
  'https://api.datapass.myqsrsoft.com';
const baseURL = `${url}/admin/get_user_role`;
async function get() {
  const token = await getToken();
  const response = await fetch(baseURL, {
    headers: {
      'x-auth-token': token,
    },
  });
  return response.json();
}

let userRole;
export default function getDataPassUser(menuItem) {
  if (!userRole) {
    userRole = ref();
    get()
      .then((response) => {
        const { success } = response;
        userRole.value = success?.role;
      })
      .catch((e) => {
        console.error(e);
      });
  }
  return computed(() => menuItem.roles?.includes(userRole.value) ?? false);
}
